var map = {
	"./column.png": 564,
	"./images/1.png": 600,
	"./images/callout.10de9efe.svg": 680,
	"./images/di.png": 544,
	"./images/headSculpture.jpg": 156,
	"./images/qq.png": 624,
	"./logo.png": 656,
	"./style/common.css": 312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;